import React from 'react';

function LegalLinks() {
  return (
    <p className="mt-12 text-base leading-normal text-retino-darkgrey sm:text-[13px]">
      {gettext('By signing up you agree to our')}{' '}
      <a
        href="https://www.retino.com/obchodni-podminky/"
        target="_blank"
        rel="noreferrer"
        className="whitespace-nowrap underline underline-offset-2"
      >
        {pgettext('registration agreement', 'Terms of Service')}
      </a>{' '}
      {gettext('and')}{' '}
      <a
        href="https://www.retino.com/ochrana-osobnich-udaju/"
        target="_blank"
        rel="noreferrer"
        className="whitespace-nowrap underline underline-offset-2"
      >
        {pgettext('registration agreement', 'Privacy Policy')}
      </a>
      .
    </p>
  );
}

export default LegalLinks;
